// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"603":"c0386f1a","657":"c8f193fe","973":"af1aff9d"}[chunkId] + ".chunk.js";
};